import { Inject, Injectable } from "@angular/core";
import {
  DataRequirements,
  DataRequirementsInjectionToken,
} from "../data.requirements";
import { ParentDetailMapper } from "../mappers/parent-detail.mapper";

@Injectable({
  providedIn: "root",
})
export class ParentDetailUseCase {
  constructor(
    private mapper: ParentDetailMapper,
    @Inject(DataRequirementsInjectionToken) private data: DataRequirements
  ) {}

  run(parentId) {
    return this.data.getParentDetail(parentId).pipe(this.mapper.map);
  }
}
